module.exports = __webpack_public_path__ + "img/instagram1.87f49cbc.png";